module.exports = __webpack_public_path__ + "img/business_2_2.3d418403.png";